import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataAPI } from "./../utils/API";
import { useHistory, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./Includes/Header";
import DashboardHeader from "./Includes/DashboardHeader";
import AdminHeader from "./Includes/AdminHeader";
import Footer from "./Includes/Footer";
import { blankProperty } from "../redux/actions/propertyAction";
import { SARAmount } from "../utils/currency";
import { refreshToken } from "../redux/actions/authAction";

/* ── Hero Buttons with hover state ── */
const HeroBtns = ({ header }) => {
	const { t } = useTranslation();
	const [hoverList, setHoverList] = useState(false);
	const [hoverInvest, setHoverInvest] = useState(false);
	const listTo = (header === "guest") ? "/login" : (header === "dashboard") ? "/dashboard/createproperty" : "/admin/createproperty";

	const handleInvestClick = (e) => {
		if (header !== 'guest') {
			e.preventDefault();
		}
		const section = document.getElementById('subscriptions-section');
		if (section) {
			e.preventDefault();
			section.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const btnBase = {
		display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
		background: '#c9a84c', color: '#ffffff',
		fontFamily: "inherit", fontWeight: 600, fontSize: '17px',
		letterSpacing: '0.04em', padding: '16px 42px',
		border: '2px solid #c9a84c', borderRadius: '6px',
		textDecoration: 'none', cursor: 'pointer', lineHeight: '1.4',
		boxShadow: '0 4px 20px rgba(201,168,76,0.45)',
		transition: 'transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
	};

	return (
		<div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center', marginTop: '8px' }}>
			<a href="#subscriptions-section"
				onClick={handleInvestClick}
				onMouseEnter={() => setHoverInvest(true)}
				onMouseLeave={() => setHoverInvest(false)}
				style={{
					...btnBase,
					transform: hoverInvest ? 'translateY(-2px)' : 'none',
					boxShadow: hoverInvest ? '0 8px 28px rgba(201,168,76,0.60)' : '0 4px 20px rgba(201,168,76,0.45)',
				}}
			>
				{t("home.investNow")}
			</a>
			<Link to={listTo}
				onMouseEnter={() => setHoverList(true)}
				onMouseLeave={() => setHoverList(false)}
				style={{
					...btnBase,
					background: hoverList ? 'rgba(255,255,255,0.18)' : 'transparent',
					borderColor: 'rgba(255,255,255,0.85)',
					color: '#ffffff',
					boxShadow: 'none',
					transform: hoverList ? 'translateY(-2px)' : 'none',
				}}
			>
				{t("home.listProperty")}
			</Link>
		</div>
	);
};

/* ── Professional Section Filter Header ── */
const SectionHeader = ({ title, filters, setFilters, cities, count, total }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const activeCount = (filters.city !== 'All' ? 1 : 0) + (filters.sector !== 'All' ? 1 : 0) + (filters.income ? 1 : 0);

	const SECTORS_TRANSLATED = [
		{ key: 'All', label: t("home.all") },
		{ key: 'Residential', label: t("home.residential") },
		{ key: 'Hospitality', label: t("home.hospitality") },
		{ key: 'Commercial', label: t("home.commercial") },
		{ key: 'Industrial', label: t("home.industrial") },
	];

	return (
		<div style={{ marginBottom: '28px' }}>
			{/* Title + controls row */}
			<div style={{
				display: 'flex', alignItems: 'center', justifyContent: 'space-between',
				flexWrap: 'wrap', gap: '12px', marginBottom: open ? '16px' : '0',
			}}>
				<div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
					<h3 style={{ margin: 0 }}>{title}</h3>
					<span style={{
						fontSize: '13px', fontWeight: 500, color: '#6b7280',
						background: '#f3f4f6', padding: '3px 10px', borderRadius: '20px',
					}}>
						{count} {count === 1 ? t("home.property") : t("home.properties")}
					</span>
					{activeCount > 0 && (
						<span style={{
							background: '#c9a84c', color: '#fff',
							fontSize: '11px', fontWeight: 700,
							padding: '2px 9px', borderRadius: '20px', letterSpacing: '0.04em',
						}}>
							{activeCount} {activeCount > 1 ? t("home.activeFilters") : t("home.activeFilter")}
						</span>
					)}
				</div>
				<button
					onClick={() => setOpen(o => !o)}
					style={{
						display: 'flex', alignItems: 'center', gap: '7px',
						background: open ? '#0e3725' : '#ffffff',
						color: open ? '#c9a84c' : '#0e3725',
						border: '1.5px solid #0e3725',
						borderRadius: '8px', padding: '9px 20px',
						fontSize: '13.5px', fontWeight: 600,
						cursor: 'pointer',
						transition: 'all 0.2s ease',
						letterSpacing: '0.02em',
						boxShadow: open ? '0 2px 12px rgba(14,55,37,0.18)' : '0 1px 4px rgba(0,0,0,0.06)',
						fontFamily: 'inherit',
					}}
				>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
						<line x1="4" y1="6" x2="20" y2="6"/>
						<line x1="8" y1="12" x2="16" y2="12"/>
						<line x1="11" y1="18" x2="13" y2="18"/>
					</svg>
					{t("home.filters")}
					{activeCount > 0 && (
						<span style={{
							background: '#c9a84c', color: '#fff',
							fontSize: '10px', fontWeight: 700,
							padding: '1px 6px', borderRadius: '10px',
						}}>
							{activeCount}
						</span>
					)}
				</button>
			</div>

			{/* Collapsible filter panel */}
			{open && (
				<div style={{
					background: '#ffffff',
					border: '1px solid #e8e4dc',
					borderRadius: '14px',
					padding: '22px 28px',
					display: 'flex',
					flexWrap: 'wrap',
					gap: '28px',
					alignItems: 'flex-end',
					boxShadow: '0 4px 24px rgba(14,55,37,0.08)',
					marginTop: '4px',
				}}>

					{/* City dropdown */}
					<div style={{ display: 'flex', flexDirection: 'column', gap: '7px', minWidth: '170px' }}>
						<label style={{
							fontSize: '10.5px', fontWeight: 700, color: '#9ca3af',
							letterSpacing: '0.10em', textTransform: 'uppercase',
						}}>
							{t("home.city")}
						</label>
						<div style={{ position: 'relative' }}>
							<select
								value={filters.city}
								onChange={e => setFilters(f => ({ ...f, city: e.target.value }))}
								style={{
									width: '100%',
									border: filters.city !== 'All' ? '1.5px solid #0e3725' : '1.5px solid #e5e7eb',
									borderRadius: '9px',
									padding: '10px 36px 10px 14px',
									fontSize: '14px',
									color: '#1f2937',
									background: filters.city !== 'All' ? 'rgba(14,55,37,0.04)' : '#fafafa',
									outline: 'none',
									cursor: 'pointer',
									appearance: 'none',
									WebkitAppearance: 'none',
									fontWeight: filters.city !== 'All' ? 600 : 400,
									transition: 'border-color 0.18s, background 0.18s',
									fontFamily: 'inherit',
								}}
							>
								<option value="All">{t("home.allCities")}</option>
								{cities.map(c => <option key={c} value={c}>{c}</option>)}
							</select>
							<svg style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
						</div>
					</div>

					{/* Sector pills */}
					<div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
						<label style={{
							fontSize: '10.5px', fontWeight: 700, color: '#9ca3af',
							letterSpacing: '0.10em', textTransform: 'uppercase',
						}}>
							{t("home.sector")}
						</label>
						<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
							{SECTORS_TRANSLATED.map(s => (
								<button
									key={s.key}
									onClick={() => setFilters(f => ({ ...f, sector: s.key }))}
									style={{
										padding: '8px 18px',
										borderRadius: '22px',
										fontSize: '13px',
										fontWeight: 600,
										cursor: 'pointer',
										border: filters.sector === s.key ? '1.5px solid #0e3725' : '1.5px solid #e5e7eb',
										background: filters.sector === s.key ? '#0e3725' : '#ffffff',
										color: filters.sector === s.key ? '#c9a84c' : '#6b7280',
										transition: 'all 0.18s ease',
										letterSpacing: '0.01em',
										boxShadow: filters.sector === s.key ? '0 2px 10px rgba(14,55,37,0.18)' : 'none',
										fontFamily: 'inherit',
									}}
								>
									{s.label}
								</button>
							))}
						</div>
					</div>

					{/* Income Generating checkbox */}
					<div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
						<label style={{
							fontSize: '10.5px', fontWeight: 700, color: '#9ca3af',
							letterSpacing: '0.10em', textTransform: 'uppercase',
						}}>
							{t("home.income")}
						</label>
						<label style={{
							display: 'flex', alignItems: 'center', gap: '10px',
							cursor: 'pointer',
							padding: '10px 18px',
							border: `1.5px solid ${filters.income ? '#0e3725' : '#e5e7eb'}`,
							borderRadius: '9px',
							background: filters.income ? 'rgba(14,55,37,0.05)' : '#fafafa',
							transition: 'all 0.18s ease',
							boxShadow: filters.income ? '0 2px 10px rgba(14,55,37,0.12)' : 'none',
						}}>
							<input
								type="checkbox"
								checked={filters.income}
								onChange={e => setFilters(f => ({ ...f, income: e.target.checked }))}
								style={{ width: '16px', height: '16px', accentColor: '#0e3725', cursor: 'pointer' }}
							/>
							<span style={{
								fontSize: '13.5px', fontWeight: 600,
								color: filters.income ? '#0e3725' : '#374151',
							}}>
								{t("home.incomeGenerating")}
							</span>
						</label>
					</div>

					{/* Clear all */}
					{activeCount > 0 && (
						<div style={{ display: 'flex', alignItems: 'flex-end' }}>
							<button
								onClick={() => setFilters({ city: 'All', sector: 'All', income: false })}
								style={{
									background: 'none', border: 'none',
									color: '#9ca3af', fontSize: '13px',
									cursor: 'pointer', textDecoration: 'underline',
									padding: '10px 4px', fontWeight: 500,
									transition: 'color 0.15s',
									fontFamily: 'inherit',
								}}
								onMouseEnter={e => e.target.style.color = '#ef4444'}
								onMouseLeave={e => e.target.style.color = '#9ca3af'}
							>
								{t("home.clearAll")}
							</button>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

/* ── Filter helper ── */
const applyFilters = (list, filters) => {
	if (!list || list === "") return [];
	return list.filter(p => {
		if (filters.city !== 'All') {
			const addr = (p.address || '').toLowerCase();
			if (!addr.includes(filters.city.toLowerCase())) return false;
		}
		if (filters.sector !== 'All') {
			const cat = (p.category || p.propertyType || p.type || '').toLowerCase();
			if (!cat.includes(filters.sector.toLowerCase())) return false;
		}
		if (filters.income) {
			if (!p.incomeGenerating && !p.rental && !p.yieldRate) return false;
		}
		return true;
	});
};

/* ── Extract unique cities from property list ── */
const extractCities = (list) => {
	if (!list || list === "") return [];
	const cities = new Set();
	list.forEach(p => {
		const addr = p.address || '';
		const parts = addr.split(',');
		if (parts.length >= 2) {
			const city = parts[parts.length - 2].trim();
			if (city) cities.add(city);
		} else if (parts.length === 1 && addr.trim()) {
			cities.add(addr.trim());
		}
	});
	return Array.from(cities).sort();
};

const Home = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [data, setData] = useState("");
	const [data1, setData1] = useState("");
	const [data2, setData2] = useState("");
	const [header, setHeader] = useState("guest");
	const [subFilters, setSubFilters] = useState({ city: 'All', sector: 'All', income: false });
	const [exFilters, setExFilters] = useState({ city: 'All', sector: 'All', income: false });
	const { auth } = useSelector((state) => state);

	useEffect(() => {
		if (auth.data) {
			let response = auth.data;
			if (response.status == 1 && response.user) {
				if (response.user.role != 1) {
					setHeader("dashboard");
				} else {
					setHeader("admin");
				}
			} else {
				setHeader("guest");
			}
		}
		async function getProperty() {
			let d1 = [];
			let d2 = [];
			const res = await getDataAPI("/get_property?status=1");
			(res.data).forEach(function (property) {
				if (parseInt((property.tokenSupply / property.totalTokenSupply) * 100) != 100) {
					d1.push(property);
				} else {
					d2.push(property);
				}
			});
			setData(res.data);
			setData1(d1);
			setData2(d2);
		}
		getProperty();
		dispatch(blankProperty());
		window.scrollTo(0, 0);
	}, [auth, dispatch]);

	const subCities = useMemo(() => extractCities(data1), [data1]);
	const exCities = useMemo(() => extractCities(data2), [data2]);
	const filteredSub = useMemo(() => applyFilters(data1, subFilters), [data1, subFilters]);
	const filteredEx = useMemo(() => applyFilters(data2, exFilters), [data2, exFilters]);

	return (
		<div>
			{
				(header == "guest") ? <Header /> : (header == "dashboard") ? <DashboardHeader /> : <AdminHeader />
			}
			<div className="main_content">
				<section className="hero-section" style={{
					padding: 0,
					margin: '0 0 0 0',
					width: '100vw',
					position: 'relative',
					left: '50%',
					transform: 'translateX(-50%)',
					marginTop: '-68px',
				}}>
					<div style={{
						height: '100vh',
						minHeight: '640px',
						width: '100%',
						display: 'flex',
						alignItems: 'center',
						backgroundImage: 'url(/theme/images/listing2.jpg)',
						backgroundSize: 'cover',
						backgroundPosition: 'center center',
						backgroundRepeat: 'no-repeat',
						position: 'relative',
						borderRadius: 0,
						overflow: 'hidden',
					}}>
						<div style={{
							position: 'absolute', inset: 0,
							background: 'linear-gradient(135deg, rgba(14,55,37,0.55) 0%, rgba(0,0,0,0.30) 100%)',
							pointerEvents: 'none',
						}} />
						<div className="container" style={{ position: 'relative', zIndex: 1 }}>
							<div style={{ maxWidth: '680px' }}>
							<p className="hero-title" style={{
								fontSize: 'clamp(2rem, 4vw, 3.2rem)',
								lineHeight: 1.25,
								color: '#ffffff',
								margin: '0 0 44px 0',
								textShadow: '0 3px 18px rgba(0,0,0,0.50)',
								fontWeight: 600,
								padding: 0,
							}}>{t("home.heroTitle")}</p>
								<HeroBtns header={header} />
							</div>
						</div>
					</div>
				</section>

				{/* Under Subscription Section */}
				<section id="subscriptions-section" className="list_latest subscriptions-section">
					<div className="container">
						<SectionHeader
							title={t("home.underSubscription")}
							filters={subFilters}
							setFilters={setSubFilters}
							cities={subCities}
							count={filteredSub.length}
							total={data1 ? data1.length : 0}
						/>
						<div className="section-frame">
							{filteredSub.length === 0 && (
								<div style={{ textAlign: 'center', padding: '40px 0', color: '#9ca3af', fontSize: '15px' }}>
									{t("home.noPropertiesFilter")}
								</div>
							)}
							<div className="list_latest_content">
								{filteredSub.map((property, i) => (
									<div className="bl_ock" key={i}>
										<div className="bl_ock_img_wrap">
											<Link to={(header == "guest") ? `/login` : (header == "dashboard") ? `/dashboard/viewproperty/${property._id}` : `/admin/viewproperty/${property._id}`}>
												<img src={`${(property.imageName && property.imageName.length > 0) ? property.imageName[0] : '/img/al_narjes.jpg'}`} alt={property.title} />
											</Link>
											<div className="bl_ock_img_overlay">
												<span className="bl_ock_location">{property.address || 'Riyadh, Saudi Arabia'}</span>
											</div>
										</div>
										<div className="bl_ock_body">
											<h4 className="bl_ock_title">{property.title}</h4>
											<div className="pr">
												<p>{t("home.unitPrice")} <SARAmount value={property.tokenPrice} decimals={0} /></p>
												<Link
													to={(header == "guest") ? `/login` : (header == "dashboard") ? `/dashboard/viewproperty/${property._id}` : `/admin/viewproperty/${property._id}`}
													className="btn">
													{t("home.subscribe")}
												</Link>
											</div>
											<div className="bar">
												<div className="progress">
													<div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ maxWidth: `${parseInt((property.tokenSupply / property.totalTokenSupply) * 100)}%` }}></div>
												</div>
												<span className="title">{parseInt((property.tokenSupply / property.totalTokenSupply) * 100)}%</span>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</section>

				{/* Exchange Market Section */}
				<section className="list_latest trades-section">
					<div className="container">
						<SectionHeader
							title={t("home.exchangeMarket")}
							filters={exFilters}
							setFilters={setExFilters}
							cities={exCities}
							count={filteredEx.length}
							total={data2 ? data2.length : 0}
						/>
						<div className="section-frame">
							{filteredEx.length === 0 && (
								<div style={{ textAlign: 'center', padding: '40px 0', color: '#9ca3af', fontSize: '15px' }}>
									{t("home.noPropertiesFilter")}
								</div>
							)}
							<div className="list_latest_content">
								{filteredEx.map((property, i) => (
									<div className="bl_ock" key={i}>
										<div className="bl_ock_img_wrap">
											<Link to={(header == "guest") ? `/login` : (header == "dashboard") ? `/dashboard/tradeproperty/${property._id}` : `/admin/tradeproperty/${property._id}`}>
												<img src={`${(property.imageName && property.imageName.length > 0) ? property.imageName[0] : '/img/al_narjes.jpg'}`} alt={property.title} />
											</Link>
											<div className="bl_ock_img_overlay">
												<span className="bl_ock_location">{property.address || 'Riyadh, Saudi Arabia'}</span>
											</div>
										</div>
										<div className="bl_ock_body">
											<h4 className="bl_ock_title">{property.title}</h4>
											<div className="pr">
												<p>{t("home.unitPrice")} <SARAmount value={property.tokenPrice} decimals={0} /></p>
												<Link
													to={(header == "guest") ? `/login` : (header == "dashboard") ? `/dashboard/tradeproperty/${property._id}` : `/admin/tradeproperty/${property._id}`}
													className="btn">
													{t("home.trade")}
												</Link>
											</div>
											<div><span className="closed_badge">{t("home.closed")}</span></div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</section>
			</div>
			<Footer />
		</div>
	);
};

export default Home;
